<template>
  <ELink :class="classes" v-bind="$attrs" v-on="$listeners">
    <slot name="default" />
  </ELink>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';
import ELink from '~~/common/vue/components/link';

export const breakpoints = ['mobile-tablet', 'desktop', 'all'];
export const sizes = ['s', 'm', 'l'];

export default {
  name: 'ELinkBubble',
  components: { ELink },
  mixins: [classes],
  props: {
    atBreakpoint: {
      type: String,
      default: 'all',
      cssClass: true,
      validator: (value) => breakpoints.includes(value),
    },
    size: {
      type: String,
      default: 's',
      cssClass: true,
      validator: (value) => sizes.includes(value),
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin unset {
  border: unset;
  border-radius: unset;
  padding: unset;
  display: unset;
  height: unset;

  &:hover {
    background-color: unset;
  }

  &:active {
    background-color: unset;
  }
}

.link-bubble {
  align-items: center;
  border: solid $border-width var(--color-decorative-border-1);
  border-radius: $border-radius-full;
  display: flex;
  justify-content: center;
  position: relative;

  &:hover {
    background-color: var(--color-button-background-transparent-hover);
  }

  &:active {
    background-color: var(--color-button-background-transparent-active);
  }

  &:focus {
    @extend %keyboard-nav-focus;
  }

  // Tappable area extender
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    height: $tappable-area-size-mobile;
    top: calc(50% - #{$tappable-area-size-mobile / 2});

    @include desktop {
      content: none;
    }
  }
}

.link-bubble--size-s {
  padding: 0 $space-s;
  height: $space-2l;
}

.link-bubble--size-m {
  padding: 0 $space-s;
  height: $space-3l;
}

.link-bubble--size-l {
  padding: 0 $space-m;
  height: $space-4l;
}

.link-bubble--at-breakpoint-mobile-tablet {
  @include desktop {
    @include unset;
  }
}

.link-bubble--at-breakpoint-desktop {
  @include desktop-down {
    @include unset;
  }
}
</style>
